import { createCommand } from '@atlassian/rovo-content-bridge-api';
import type {
	CommandConstructor,
	CommandProperties,
	SerializableValue,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link OpenPreviewPanelCommand}
 */
export interface OpenPreviewPanelCommandProperties extends CommandProperties {
	/**
	 * URL of the content to preview
	 */
	url: string;
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
}

export const OpenPreviewPanelCommand: CommandConstructor<
	OpenPreviewPanelCommandProperties,
	SerializableValue
> = createCommand<OpenPreviewPanelCommandProperties>('open-preview-panel');

/**
 * @see {@link IsPreviewPanelAvailableCommand}
 */
export interface IsPreviewPanelAvailableCommandProperties extends CommandProperties {
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
}

export const IsPreviewPanelAvailableCommand: CommandConstructor<
	IsPreviewPanelAvailableCommandProperties,
	boolean
> = createCommand<IsPreviewPanelAvailableCommandProperties, boolean>('is-preview-panel-available');

/**
 * @see {@link PreviewPanelClosedMessage}
 */
export interface PreviewPanelClosedMessageProperties extends CommandProperties {
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
	/**
	 * Product identifier of the preview panel
	 */
	product?: string;
	/**
	 * Type of the preview panel
	 */
	type?: string;
}

export const PreviewPanelClosedMessage: CommandConstructor<
	PreviewPanelClosedMessageProperties,
	SerializableValue
> = createCommand<PreviewPanelClosedMessageProperties>('preview-panel-closed');

/**
 * @see {@link PreviewPanelOpenedMessage}
 */
export interface PreviewPanelOpenedMessageProperties extends CommandProperties {
	/**
	 * ARI (Atlassian Resource Identifier) of the content
	 */
	ari: string;
	/**
	 * Product identifier of the preview panel
	 */
	product?: string;
	/**
	 * Type of the preview panel
	 */
	type?: string;
	/**
	 * Width of the preview panel in pixels
	 */
	width?: number;
}

export const PreviewPanelOpenedMessage: CommandConstructor<
	PreviewPanelOpenedMessageProperties,
	SerializableValue
> = createCommand<PreviewPanelOpenedMessageProperties>('preview-panel-opened');
